import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Divider,
    FormControlLabel,
    Grid,
    List,
    ListItem,
    OutlinedInput,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CustomizedStepper from "../CustomisedStepper";
import { DocumentUpload } from "../DocumentUpload";
import PhoneIcon from "@mui/icons-material/Phone";
import { ArrowBack as ArrowBackIcon, Refresh as RefreshIcon } from "@mui/icons-material";
import CustomiseTooltip from "../CustomiseTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { iconMapping } from "../DocumentUpload/iconMapping";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { LoadingButton } from "@mui/lab";
import { post } from "../../api";
import { save } from "../../services/object";
import { MultipleUpload } from "../DocumentUpload/multipleUpload";

const INITIAL_SCREEN_DATA = [
    {
        id: "1",
        heading: "Most Recent Tax Return",
        para: "Upload your latest tax return. If your business is new, we may request additional documents for verification.",
    },
    {
        id: "2",
        heading: "Proof of Business Ownership",
        para: "Upload proof of ownership documentation",
    },
    {
        id: "3",
        heading: "Business Bank or Account Statements",
        para: "Upload business bank statements or any account statements used to verify income",
    },
    {
        id: "4",
        heading: "YTD Profit & Loss Statement",
        para: "Upload your year-to-date Profit and Loss statement. You can use your own format, or we can provide a template for you.",
    },
];

const successReasons = [];
const selfEmployedData = (record) => {
    let steps1 = {};
    let steps2 = {};
    let steps3 = {};
    let steps4 = {};

    for (let document of record.incomeDocuments || []) {
        if (document.stepId === "1") {
            steps1 = { ...document, fileIds: document.fileId?.split(";") };
        }
        if (document.stepId === "2") {
            steps2 = { ...document, fileIds: document.fileId?.split(";") };
        }
        if (document.stepId === "3") {
            steps3 = { ...document, fileIds: document.fileId?.split(";") };
        }
        if (document.stepId === "4") {
            steps4 = { ...document, fileIds: document.fileId?.split(";") };
        }
    }

    for (let document of record.s3Documents || []) {
        if (steps1.fileIds?.indexOf(document.fileId) > -1) {
            steps1.uploadedDocFile = [...(steps1.uploadedDocFile || []), document];
        } else if (steps2.fileIds?.indexOf(document.fileId) > -1) {
            steps2.uploadedDocFile = [...(steps2.uploadedDocFile || []), document];
        } else if (steps3.fileIds?.indexOf(document.fileId) > -1) {
            steps3.uploadedDocFile = [...(steps3.uploadedDocFile || []), document];
        } else if (steps4.fileIds?.indexOf(document.fileId) > -1) {
            steps4.uploadedDocFile = [...(steps4.uploadedDocFile || []), document];
        }
    }

    return [
        {
            id: "1",
            mainHeading: "Most Recent Tax Return",
            mainPara: "Please upload your most recent complete tax return for verification.",
            uploadHeading: "Upload Most Recent Tax Return",
            reasonForSkip: steps1.reasonForSkip ? steps1.reasonForSkip : "",
            reasonType: steps1.reasonType ? steps1.reasonType : "",
            optionsForReasonOfSkip: [
                {
                    id: "01",
                    label: "First year in business",
                    value: "First year in business",
                    isChecked: false,
                },
                {
                    id: "02",
                    label: "Incomplete or Unfiled Taxes",
                    isChecked: false,
                    value: "Incomplete or Unfiled Taxes",
                },
            ],
            uploadedDocFile: steps1.uploadedDocFile ? steps1.uploadedDocFile : null,
        },
        {
            id: "2",
            mainHeading: "Proof of Business Ownership",
            mainPara: "Upload proof of ownership documentation",
            reasonForSkip: steps2.reasonForSkip ? steps2.reasonForSkip : "",
            reasonType: steps2.reasonType ? steps2.reasonType : "",
            optionsForReasonOfSkip: [
                {
                    id: "01",
                    label: "I'm a sole proprietor and haven't formally registered my business",
                    value: "I'm a sole proprietor and haven't formally registered my business",
                    // isChecked: false,
                },
                {
                    id: "02",
                    label: "I'm a 1099 independent contractor",
                    value: "I'm a 1099 independent contractor",
                    isChecked: false,
                },
            ],
            uploadHeading: "Upload Article of Incorporation Document ",
            uploadedDocFile: steps2.uploadedDocFile ? steps2.uploadedDocFile : null,
        },
        {
            id: "3",
            mainHeading: "Business Bank Statement or Financial Statement",
            mainPara:
                "Upload your year-to-date business bank statements or any financial statements used to verify your income.",
            reasonForSkip: steps3.reasonForSkip ? steps3.reasonForSkip : "",
            reasonType: steps3.reasonType ? steps3.reasonType : "",
            optionsForReasonOfSkip: [
                {
                    id: "01",
                    label: "I don’t have this document",
                    value: "I don’t have this document",
                    isChecked: false,
                },
            ],

            uploadHeading: "Bank Statements",
            uploadedDocFile: steps3.uploadedDocFile ? steps3.uploadedDocFile : null,
        },
        {
            id: "4",
            mainHeading: "YTD Profit & Loss Statement",
            mainPara:
                "Upload your year-to-date Profit and Loss statement. You can use your own format, or we can provide a template for you..",
            reasonForSkip: steps4.reasonForSkip ? steps4.reasonForSkip : "",
            reasonType: steps4.reasonType ? steps4.reasonType : "",
            optionsForReasonOfSkip: [
                {
                    id: "01",
                    label: "What is a P&L Statement?",
                    value: "What is a P&L Statement?",
                    isChecked: false,
                },
                {
                    id: "01",
                    label: "I don’t have this document",
                    value: "I don’t have this document",
                    isChecked: false,
                },
            ],

            uploadHeading: "Upload YTD Business Profit & Loss Statement",
            uploadedDocFile: steps4.uploadedDocFile ? steps4.uploadedDocFile : null,

            description: {
                heading: " Main Parts of a P&L Statement",
                list: [
                    "Revenue: Total earnings from sales or services.",
                    "Expenses: Includes costs like salaries, rent, and supplies.",
                    "Net Profit (or Loss): What remains after deducting expenses from revenue.",
                ],
            },
        },
    ];
};
function SelfEmployed({
    incomeDetails,
    userDetails,
    setSelfEmployedIncomeModalInfo,
    onAddIncomeComplete,
    editMode,
    onClose = () => {},
}) {
    const [mainData, setMainData] = useState([...selfEmployedData(incomeDetails)]);
    const [isAlreadyProceed, setIsAlreadyProceed] = useState(false);
    const [activeStep, setActiveStep] = useState(0);

    const [currentData, setCurrentData] = useState({});
    const [isSkippedClicked, setIsSkippedClicked] = useState({});

    const [documentUploadDoneLoading, setDocumentUploadDoneLoading] = useState(false);

    const handleProceed = () => {
        setIsAlreadyProceed(true);
    };

    const handleNextORContinue = (type, value, selected) => {
        if (type === "Next" || type === "Continue") {
            let newData = {
                ...currentData,
            };

            // if press Next but file is not uploaded
            if (
                type === "Next" &&
                !(
                    currentData?.uploadedDocFile?.length > 0 ||
                    (currentData?.reasonForSkip && successReasons.indexOf(currentData?.reasonForSkip) > -1)
                )
            ) {
                // if file not uploaded
                return;
            }

            if (type === "Continue") {
                // if press continue but value not present
                if (!value) {
                    return;
                }

                // if press continue but value  present
                newData = {
                    ...currentData,
                    reasonForSkip: value,
                    reasonType: selected,
                };
            }

            // update main data here and go to next step
            const newMainData = mainData?.map((cItem) => {
                if (cItem.id === newData.id) {
                    return newData;
                } else {
                    return cItem;
                }
            });

            setCurrentData(newData);
            setMainData(newMainData);

            // upload data on database using api here

            if (activeStep < mainData.length - 1) {
                //0<3
                setActiveStep((prevStep) => prevStep + 1);
            } else {
                handleDocumentUploadDone(newMainData); // close modal on last step
            }
        }
    };

    const prepareDocumentData = (newMainData) => {
        let s3Documents = [];
        let documentRecords = [];
        for (let item of newMainData) {
            if (item.uploadedDocFile && item.uploadedDocFile.length > 0) {
                item.uploadedDocFile.forEach((cItem, index) => {
                    s3Documents.push({
                        ...cItem,
                        name: item.mainHeading + " " + (index + 1),
                    });
                });
                documentRecords.push({
                    ...item.uploadedDocFile,
                    fileId: item.uploadedDocFile
                        .filter((item) => !item.isDeleted)
                        .map((cItem) => cItem.fileId)
                        .join(";"),
                    stepId: item.id,
                    name: item.mainHeading,
                    label: item.mainHeading,
                    reasonForSkip: item.reasonForSkip,
                    reasonType: item.reasonType,
                    isCompleted: true,
                });
            } else {
                documentRecords.push({
                    stepId: item.id,
                    name: item.mainHeading,
                    label: item.mainHeading,
                    reasonForSkip: item.reasonForSkip,
                    reasonType: item.reasonType,
                    isCompleted: successReasons.indexOf(item.reasonForSkip) > -1 ? true : false,
                });
            }
        }

        return { documentRecords, s3Documents };
    };

    const getIncomeData = (documentRecords) => {
        let incomeDetail = { ...incomeDetails };
        if (documentRecords?.length > 0 && documentRecords.filter((item) => !item.isCompleted).length > 0) {
            incomeDetail.serverErrorMessage = `Oops! The following documents are missing:
            ${documentRecords
                ?.filter((item) => !item.isCompleted)
                .map((item) => item.name)
                .join(", ")}
            .`;
        } else {
            incomeDetail.serverErrorMessage = "";
        }
        return incomeDetail;
    };

    const handleDocumentUploadDone = async (newMainData) => {
        setDocumentUploadDoneLoading(true);

        let { documentRecords, s3Documents } = prepareDocumentData(newMainData);

        let result = await post("income/addIncomeDetails", {
            applicantId: userDetails?.applicant?.id,
            income: getIncomeData(documentRecords),
            incomeDocuments: documentRecords?.map((item) => ({
                ...item,
                id: undefined,
            })),
        });
        if (result.isSuccess) {
            let documentRecords = s3Documents?.map((item) => {
                if (item.parentId) {
                    return item;
                }
                return {
                    ...item,
                    parentId: result.data.id,
                };
            });

            let documentResult = await save("document", documentRecords);
            onAddIncomeComplete(result.data, editMode);

            onClose();
        }
        setDocumentUploadDoneLoading(false);
    };

    // const handleNext = () => {
    //     // first check related document is uploaded the next

    //     // if file not uploaded
    //     if (!currentData?.uploadedDocFile) {
    //         return;
    //     }

    //     // update on main data
    //     const updateMainData = mainData.map((cItem) => {
    //         if (cItem?.id === currentData?.id) {
    //             return currentData;
    //         }

    //         return cItem;
    //     });
    //     setMainData(updateMainData);

    //     if (activeStep < mainData.length - 1) {
    //         //0<3
    //         setActiveStep((prevStep) => prevStep + 1);
    //     } else {
    //         onClose();
    //     }
    // };

    const handleSkip = (currentData = {}) => {
        setIsSkippedClicked(true);
    };
    const handleSkipBack = () => {
        setIsSkippedClicked(false);
    };

    // const handleContinue = (selectedValue) => {
    //     if (selectedValue) {
    //         const newData = {
    //             ...currentData,
    //             reasonForSkip: selectedValue,
    //         };
    //         const newMainData = mainData?.map((cItem) => {
    //             if (cItem.id === newData.id) {
    //                 return newData;
    //             } else {
    //                 return cItem;
    //             }
    //         });

    //         setCurrentData(newData);
    //         setMainData(newMainData);

    //         if (activeStep < mainData.length - 1) {
    //             //0<3
    //             setActiveStep((prevStep) => prevStep + 1);
    //         } else {
    //             onClose();
    //         }
    //     }
    // };

    const handleFileUploadComplete = (files) => {
        const newData = {
            ...currentData,
            uploadedDocFile: [...(currentData.uploadedDocFile || []), ...files],
            reasonForSkip: "",
            reasonType: "",
        };

        setCurrentData(newData);
    };

    // console.log({ currentData, mainData });

    useEffect(() => {
        const cData = mainData[activeStep];
        setCurrentData(cData);
        setIsSkippedClicked(false);
    }, [activeStep, mainData]);

    useEffect(() => {
        if (!isAlreadyProceed) {
            return setSelfEmployedIncomeModalInfo((prevState) => ({
                ...prevState,
                heading: "Here’s What To Expect",
                hidePara: false,
                para: "Submit the required documents below to complete your application.",
            }));
        }
        if (activeStep === 0) {
            setSelfEmployedIncomeModalInfo((prevState) => ({
                ...prevState,
                heading: "Let's get started!",
                hidePara: true,
            }));
        }
        if (activeStep === 1) {
            setSelfEmployedIncomeModalInfo((prevState) => ({
                ...prevState,
                heading: "You're doing great!",
                hidePara: true,
            }));
        }
        if (activeStep === 2) {
            setSelfEmployedIncomeModalInfo((prevState) => ({
                ...prevState,

                heading: "Halfway there!",
                hidePara: true,
            }));
        }
        if (activeStep === mainData?.length - 1) {
            setSelfEmployedIncomeModalInfo((prevState) => ({
                ...prevState,
                heading: "Last one!",
            }));
        }
    }, [activeStep, isAlreadyProceed]);

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} flexDirection={"column"}>
            {!isAlreadyProceed ? (
                <InitialScreenUI handleProceed={handleProceed} />
            ) : (
                <>
                    <Box margin={"1rem 0"} width={"100%"}>
                        <CustomizedStepper
                            successReasons={successReasons}
                            activeStep={activeStep}
                            setActiveStep={setActiveStep}
                            steps={mainData}
                        />
                    </Box>

                    {!isSkippedClicked ? (
                        <>
                            <Box margin={"1rem 0"}>
                                <Typography
                                    variant="subtitle2"
                                    component="h5"
                                    textAlign={"center"}
                                    lineHeight={"20px"}
                                    fontWeight={600}
                                    display={"flex"}
                                    justifyContent={"center"}
                                    alignItems={"center"}>
                                    {currentData.mainHeading}
                                    {currentData?.description && (
                                        <CustomiseTooltip
                                            title={
                                                <Box>
                                                    <Typography
                                                        variant="body2"
                                                        component={"h5"}
                                                        color={"#fff"}
                                                        fontWeight={600}>
                                                        {currentData?.description?.heading}
                                                    </Typography>

                                                    <Box
                                                        component={"ul"}
                                                        sx={{
                                                            marginLeft: "1.2rem",
                                                            marginTop: "0.4rem",
                                                        }}>
                                                        {currentData?.description?.list?.map((cListItem) => (
                                                            <li>{cListItem}</li>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            }
                                        />
                                    )}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    component="p"
                                    textAlign={"center"}
                                    lineHeight={"20px"}
                                    marginTop={"0.2rem"}
                                    fontSize={".75rem"}>
                                    {currentData.mainPara}
                                </Typography>
                            </Box>

                            <Card
                                sx={{
                                    background: "#F9F9FA",
                                    width: "100%",
                                    border: "1px solid #EAECF0",
                                }}>
                                <CardContent>
                                    <Typography
                                        variant="body2"
                                        component="p"
                                        textAlign={"center"}
                                        lineHeight={"24px"}
                                        fontWeight={500}>
                                        {currentData.uploadHeading}
                                    </Typography>

                                    <UploadDocFileUI
                                        activeStep={activeStep}
                                        handleFileUploadComplete={handleFileUploadComplete}
                                        currentData={currentData}
                                        setCurrentData={setCurrentData}
                                    />

                                    <Divider sx={{ marginY: "16px" }}></Divider>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: {
                                                xs: "column",
                                                sm: "row",
                                            },
                                        }}>
                                        <Button
                                            disabled={
                                                currentData?.uploadedDocFile &&
                                                currentData?.uploadedDocFile?.length !== 0
                                            }
                                            onClick={() => handleSkip(currentData)}
                                            color="secondary"
                                            fullWidth
                                            variant="outlined"
                                            sx={{
                                                height: "45px",
                                                color: "#3F3F46",
                                            }}
                                            id="understood-btn">
                                            <b>Skip For Now</b>
                                        </Button>
                                        <LoadingButton
                                            loading={documentUploadDoneLoading}
                                            onClick={() => handleNextORContinue("Next")}
                                            color="primary"
                                            fullWidth
                                            variant="contained"
                                            sx={{
                                                height: "45px",
                                                marginLeft: {
                                                    xs: "0",
                                                    sm: "0.5rem",
                                                },
                                                marginTop: {
                                                    xs: "0.5rem",
                                                    sm: "0rem",
                                                },
                                            }}
                                            id="understood-btn"
                                            disabled={
                                                !(
                                                    currentData?.uploadedDocFile?.length > 0 ||
                                                    (currentData?.reasonForSkip &&
                                                        successReasons.indexOf(currentData?.reasonForSkip) > -1)
                                                )
                                            }>
                                            {activeStep < mainData.length - 1 ? "Continue" : "Finish"}
                                        </LoadingButton>
                                    </Box>

                                    <FooterUI />
                                </CardContent>
                            </Card>
                        </>
                    ) : (
                        <>
                            <CurrentSkipStepUI
                                handleSkipBack={handleSkipBack}
                                currentData={currentData}
                                activeStep={activeStep}
                                mainData={mainData}
                                handleNextORContinue={handleNextORContinue}
                                radioSkipReasonOptions={currentData?.optionsForReasonOfSkip || []}
                            />
                        </>
                    )}
                    <></>
                </>
            )}
        </Box>
    );
}

const CurrentSkipStepUI = ({
    handleSkipBack,
    activeStep,
    mainData,
    currentData,
    handleNextORContinue,
    radioSkipReasonOptions = [],
}) => {
    const [radioSelectedValue, setRadioSelectedValue] = useState(currentData?.reasonType);
    const [otherReason, setOtherReason] = useState(currentData?.reasonForSkip);
    // const [radioSkipReasonOptions, setRadioSkipReasonOptions] = useState([]);

    const handleRadioInputChange = (event) => {
        setRadioSelectedValue(event.target.value);
        if (currentData?.reasonType !== "Other") {
            setOtherReason("");
        }
    };

    return (
        <>
            <Box sx={{ width: "100%" }}>
                <Box margin={"1rem 0"}>
                    <Typography
                        variant="subtitle2"
                        component="h5"
                        textAlign={"center"}
                        lineHeight={"20px"}
                        fontWeight={600}>
                        Reason For Skipping?
                    </Typography>
                    <Typography variant="body2" component="p" textAlign={"center"} lineHeight={"20px"}>
                        Please select a reason.
                    </Typography>
                </Box>

                <Card
                    sx={{
                        background: "#F9F9FA",
                        width: "100%",
                        border: "1px solid #EAECF0",
                    }}>
                    <CardContent>
                        <RadioGroup
                            name="radio-buttons-group"
                            onChange={handleRadioInputChange}
                            value={radioSelectedValue}
                            aria-label="radio-group">
                            {radioSkipReasonOptions?.map((column, index) => (
                                <Box
                                    key={index}
                                    component="span"
                                    sx={{
                                        px: 1,
                                        borderRadius: "10px",
                                        border: "1px solid",
                                        mt: index === 0 ? 0 : 1,
                                        backgroundColor: column.value === radioSelectedValue ? "#ECFDFF" : "#fff",
                                        borderColor: column.value === radioSelectedValue ? "#06AED4" : "#E4E4E7",
                                        width: "100%",

                                        display: "flex",
                                        justifyContent: "space-between",
                                        aligmItems: "center",
                                    }}>
                                    <FormControlLabel
                                        sx={{
                                            display: "flex",
                                            alignItems: "start",
                                        }}
                                        value={column.value}
                                        control={<Radio />}
                                        label={
                                            <Typography
                                                sx={{
                                                    // mt: "10px",
                                                    padding: "10px 0 5px 0px",
                                                }}
                                                variant="subtitle1">
                                                {column.label}
                                                <span
                                                    style={{
                                                        // color:
                                                        //     column.value ===
                                                        //     inputValue
                                                        //         ? "#000000"
                                                        //         : "#90a4ae",
                                                        fontSize: ".75rem",
                                                        fontWeight: 400,
                                                        lineHeight: 1.5,
                                                    }}>
                                                    {column.subheading ? " " + column.subheading : ""}
                                                </span>
                                            </Typography>
                                        }
                                    />

                                    {column.value === "What is a P&L Statement?" && currentData?.description && (
                                        <CustomiseTooltip
                                            buttonSx={{
                                                marginLeft: 0,
                                                height: "42px",
                                            }}
                                            title={
                                                <Box>
                                                    <Typography
                                                        variant="body2"
                                                        component={"h5"}
                                                        color={"#fff"}
                                                        fontWeight={600}>
                                                        {currentData?.description?.heading}
                                                    </Typography>

                                                    <Box
                                                        component={"ul"}
                                                        sx={{
                                                            marginLeft: "1.2rem",
                                                            marginTop: "0.4rem",
                                                        }}>
                                                        {currentData?.description?.list?.map((cListItem) => (
                                                            <li>{cListItem}</li>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            }
                                        />
                                    )}
                                </Box>
                            ))}
                            <Box
                                component="span"
                                sx={{
                                    px: 1,
                                    borderRadius: "10px",
                                    border: "1px solid",
                                    mt: 1,
                                    backgroundColor: "Other" === radioSelectedValue ? "#ECFDFF" : "#fff",
                                    borderColor: "Other" === radioSelectedValue ? "#06AED4" : "#E4E4E7",
                                    width: "100%",
                                }}>
                                <FormControlLabel
                                    sx={{
                                        display: "flex",
                                        alignItems: "start",
                                    }}
                                    value={"Other"}
                                    control={<Radio />}
                                    label={
                                        <Typography
                                            sx={{
                                                padding: "10px 0 5px 0px",
                                            }}
                                            variant="subtitle1">
                                            Other
                                        </Typography>
                                    }
                                />

                                {radioSelectedValue === "Other" && (
                                    <OutlinedInput
                                        placeholder="Please write here"
                                        multiline
                                        sx={{
                                            marginBottom: "0.5rem",
                                            "& textarea": {
                                                padding: "0.5rem",
                                            },
                                            "& textarea::placeholder": {
                                                color: "#70707B",
                                                fontSize: "12px",
                                                fontFamily: `"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji"`,
                                            },

                                            padding: 0,
                                        }}
                                        minRows={3}
                                        maxRows={3}
                                        value={otherReason}
                                        onChange={(e) => setOtherReason(e.target.value)}
                                        disabled={radioSelectedValue !== "Other"}
                                    />
                                )}
                            </Box>
                        </RadioGroup>

                        <Divider sx={{ marginY: "16px" }}></Divider>

                        <Box display={"flex"}>
                            <Button
                                color="secondary"
                                fullWidth
                                variant="outlined"
                                sx={{
                                    height: "45px",
                                    color: "#3F3F46",
                                    marginRight: "0.5rem",
                                }}
                                id="understood-btn"
                                startIcon={<ArrowBackIcon />}
                                onClick={handleSkipBack}>
                                Back
                            </Button>
                            <Button
                                onClick={() => {
                                    if (radioSelectedValue === "Other") {
                                        handleNextORContinue("Continue", otherReason, radioSelectedValue);
                                    } else {
                                        handleNextORContinue("Continue", radioSelectedValue, radioSelectedValue);
                                    }
                                }}
                                color="primary"
                                fullWidth
                                variant="contained"
                                sx={{ height: "45px" }}
                                id="understood-btn"
                                disabled={!radioSelectedValue || (radioSelectedValue === "Other" && !otherReason)}>
                                {activeStep < mainData.length - 1 ? "Continue" : "Finish"}
                            </Button>
                        </Box>

                        <FooterUI />
                    </CardContent>
                </Card>
            </Box>
        </>
    );
};

const InitialScreenUI = ({ handleProceed }) => {
    return (
        <>
            {" "}
            <Card sx={{ width: "100%", padding: "12px" }}>
                <CardContent>
                    <Box
                        component={"ul"}
                        sx={{
                            listStyle: "decimal",
                            listStylePosition: "inside",
                        }}>
                        <List sx={{ padding: 0 }}>
                            {INITIAL_SCREEN_DATA.map((cItem, index) => (
                                <ListItem
                                    sx={{
                                        padding: "0 0 1rem 0",
                                        alignItems: "flex-start",
                                        "&:last-child": {
                                            paddingBottom: 0,
                                        },
                                    }}>
                                    <Typography
                                        variant="subtitle2"
                                        component="div"
                                        sx={{
                                            marginRight: "0.5rem",
                                        }}>
                                        {index + 1}.
                                    </Typography>

                                    <Box>
                                        <Typography
                                            variant="subtitle2"
                                            component="h5"
                                            fontWeight={"600"}
                                            lineHeight={"20px"}
                                            marginBottom={"0.2rem"}
                                            fontSize={"14px"}>
                                            {cItem.heading}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            component="p"
                                            lineHeight={"20px"}
                                            color={"#596066"}
                                            fontWeight={500}
                                            fontSize={".75rem"}
                                            sx={{}}>
                                            {cItem.para}
                                        </Typography>
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </CardContent>
            </Card>
            <Button
                onClick={handleProceed}
                color="primary"
                fullWidth
                variant="contained"
                sx={{ height: "45px", mt: "1rem" }}
                id="understood-btn">
                I Understand & Proceed
            </Button>
        </>
    );
};

const FooterUI = () => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "1rem",
            }}>
            <PhoneIcon
                sx={{
                    color: "#1F4E66",
                    fontSize: "18px",
                }}></PhoneIcon>
            <Box
                sx={{
                    color: "#1F4E66",
                    fontSize: "14px",
                    ml: ".75rem",
                }}>
                Need help? <span style={{ color: "#70707B" }}>Call (877) 958-1888</span>
            </Box>
        </Box>
    );
};

const UploadDocFileUI = ({ activeStep, handleFileUploadComplete, currentData = {}, setCurrentData = () => {} }) => {
    const documentUploadRef = useRef();

    const getExtension = (name) => {
        if (name) {
            return name.substring(name.lastIndexOf(".") + 1);
        }
        return "";
    };

    const getIcon = (fileName) => {
        const extension = getExtension(fileName);
        const icon = iconMapping[extension]?.icon;
        return icon ? icon : faFile;
    };

    const getColor = (fileName) => {
        const extension = getExtension(fileName);
        const color = iconMapping[extension]?.color;
        return color ? color : "#413ab4";
    };

    const handleRefresh = (event, document) => {
        event.stopPropagation();
        handleDelete(event, document);

        setTimeout(() => {
            documentUploadRef?.current?.uploadFile();
        }, 500);
    };

    const handleDelete = (event, document) => {
        event.stopPropagation();
        let documents = [...currentData.uploadedDocFile];
        let doc = documents?.find((item) => item.fileId === document.fileId && !item.isDeleted);

        // console.log({ doc, documents });

        if (doc) {
            if (doc.parentId) {
                documents = documents?.map((item) => {
                    if (doc.fileId === item.fileId) {
                        item.isDeleted = true;
                    }
                    return item;
                });
                //documents = documents?.filter((item) => doc.fileId !== item.fileId); // for deleting item
            } else {
                documents = documents?.filter((item) => doc.fileId !== item.fileId);
            }
            currentData.uploadedDocFile = documents;
            setCurrentData({ ...currentData });
        }
    };

    const getDocuments = () => {
        if (currentData.uploadedDocFile) {
            return currentData.uploadedDocFile.filter((item) => !item.isDeleted);
        }
        return [];
    };

    return (
        <>
            <MultipleUpload
                key={activeStep}
                parentId={""}
                userDetails={{}}
                onFileUploadComplete={handleFileUploadComplete}
                ref={documentUploadRef}></MultipleUpload>
            {currentData?.uploadedDocFile?.length > 0 && (
                <>
                    {getDocuments()?.map((cFile, index) => (
                        <Card
                            sx={{
                                position: "relative",
                                cursor: "pointer",
                                marginTop: "1rem",
                                background: "transparent",
                                borderRadius: "8px",
                                border: "1px dashed var(--Neutral-200, #D0D5DD)",
                                boxShadow: "none",
                            }}
                            // onClick={() => onCardClick(currentData?.uploadedDocFile)}
                        >
                            <CardContent>
                                <Stack direction={"row"} justifyContent={"start"} alignItems={"start"} gap={"16px"}>
                                    <Stack sx={{ color: getColor(cFile.fileName) }} gap={"10px"}>
                                        <FontAwesomeIcon style={{ fontSize: "3rem" }} icon={getIcon(cFile.fileName)} />
                                        <Typography
                                            sx={{
                                                marginTop: "-8px",
                                                textTransform: "uppercase",
                                                fontSize: "10px",
                                            }}
                                            component="div"
                                            noWrap
                                            variant="caption"
                                            color="text.secondary"></Typography>
                                    </Stack>
                                    <Stack
                                        direction={"row"}
                                        justifyContent={"space-between"}
                                        alignItems={"center"}
                                        sx={{ width: "100%" }}>
                                        <Box>
                                            <Typography
                                                noWrap
                                                gutterBottom
                                                variant="h6"
                                                component="div"
                                                fontSize={"14px"}
                                                sx={{ width: "212px" }}>
                                                {cFile.name}
                                            </Typography>
                                            <Stack
                                                direction={"row"}
                                                gap={"2px"}
                                                justifyContent={"start"}
                                                alignItems={"center"}>
                                                <Button
                                                    sx={{
                                                        p: 1,
                                                        height: "21px",
                                                        fontSize: "12px",
                                                        minWidth: "auto",
                                                        fontWeight: 400,
                                                    }}
                                                    color="error"
                                                    variant="outlined"
                                                    onClick={(event) => handleDelete(event, cFile)}>
                                                    Delete
                                                </Button>
                                                <Button
                                                    sx={{
                                                        p: 1,
                                                        height: "21px",
                                                        fontSize: "12px",
                                                        fontWeight: 400,
                                                        color: "#858585",
                                                    }}
                                                    variant="outlined"
                                                    color="inherit"
                                                    onClick={(event) => handleRefresh(event, cFile)}>
                                                    Refresh
                                                </Button>
                                            </Stack>
                                        </Box>
                                    </Stack>
                                </Stack>
                            </CardContent>
                        </Card>
                    ))}
                </>
            )}
        </>
    );
};

export default SelfEmployed;
